import moment from "moment";

export const mapEndDatePeriodLast = (endDate) =>{
    return moment(endDate).subtract(1, "years").format("DD/MM/YYYY")
}
